import { ListingsResponseSchema, type ListingsResponse } from "@housing/shared";

import { reportSchemaError } from "@/diagnostics/schema-error.ts";

/**
 * `/api/listings` is a trust boundary — the response is parsed against the
 * shared schema rather than cast, so a contract change surfaces here (as a
 * toast plus a console report) instead of as an undefined three components deep.
 */
export async function fetchListings(): Promise<ListingsResponse> {
  const res = await fetch("/api/listings");
  if (!res.ok) throw new Error(`/api/listings → HTTP ${res.status}`);

  const parsed = ListingsResponseSchema.safeParse(await res.json());
  if (!parsed.success) {
    reportSchemaError("ListingsResponse", parsed.error);
    throw new Error("the response didn't match the expected schema");
  }
  return parsed.data;
}
